import { session } from 'wix-storage';
import { getCountryInfo,  getCountryInformation } from 'backend/country';
import {fetch} from 'wix-fetch';
import wixWindow from 'wix-window';

let countryInfo;

$w.onReady(async function () {
	if(session.getItem("countryInfo")){
		countryInfo = JSON.parse(session.getItem("countryInfo"));
		setDetails();
	}else{
		getCountryDetails()
	}
});

function setDetails() {
	    // $w("#image21").src = countryInfo.flag;
        // $w("#text48").text = countryInfo.name+ "  - Free Shipping";
        $w("#text48").text = countryInfo.name;
        $w("#image21").show()
        $w("#text48").show();
        $w("#image21").expand()
        $w("#text48").expand();
		session.setItem("countryInfo", JSON.stringify(countryInfo));
}

function getCountryDetails () {
	fetch('https://extreme-ip-lookup.com/json', {
			method: 'get'
		})
		.then((httpResponse) => {
			if (httpResponse.ok) {
				return httpResponse.json();
			}
		})
		.then(async (json) => {
			const ipaddress = json.query;
			let country = await getCountryInformation(ipaddress)
			countryInfo = await getCountryInfo(country.country);
			setDetails();
		});
}

$w.onReady(function () {
	
});

export function turkishCeramicsButton_mouseIn_2(event) {
$w("#turkishCeramicsMenu").expand() 
}

export function turkishCeramicsButton_mouseOut_2(event) {
$w("#turkishCeramicsMenu").collapse() 
}

export function turkishCeramicsMenu_mouseIn_1(event) {
$w("#turkishCeramicsMenu").expand() 
}

export function turkishCeramicsMenu_mouseOut_1(event) {
$w("#turkishCeramicsMenu").collapse() 
}

export function lightingButton_mouseIn_1(event) {
$w("#lightingMenu").expand()
}

export function lightingButton_mouseOut_1(event) {
$w("#lightingMenu").collapse()
}

export function lightingMenu_mouseIn(event) {
$w("#lightingMenu").expand() 
}

export function lightingMenu_mouseOut(event) {
$w("#lightingMenu").collapse()
}

export function foodButton_mouseIn_1(event) {
$w("#foodMenu").expand()
}

export function foodButton_mouseOut_1(event) {
$w("#foodMenu").collapse()
}

export function foodMenu_mouseIn_1(event) {
$w("#foodMenu").expand()
}

export function foodMenu_mouseOut_1(event) {
$w("#foodMenu").collapse()
}

export function decorButton_mouseIn_1(event) {
$w("#decorMenu").expand()
}

export function decorButton_mouseOut_1(event) {
$w("#decorMenu").collapse()
}

export function decorMenu_mouseIn_1(event) {
$w("#decorMenu").expand()
}

export function decorMenu_mouseOut_1(event) {
$w("#decorMenu").collapse()
}

export function textileButton_mouseIn(event) {
$w("#textileMenu").expand()
}

export function textileButton_mouseOut(event) {
$w("#textileMenu").collapse()
}

export function textileMenu_mouseIn(event) {
$w("#textileMenu").expand()
}

export function textileMenu_mouseOut(event) {
$w("#textileMenu").collapse()
}

export function hammamButton_mouseIn(event) {
$w("#hammamMenu").expand()
}

export function hammamButton_mouseOut(event) {
$w("#hammamMenu").collapse()
}

export function hammamMenu_mouseIn(event) {
$w("#hammamMenu").expand()
}

export function hammamMenu_mouseOut(event) {
$w("#hammamMenu").collapse()
}

export function copperButton_mouseIn(event) {
$w("#copperMenu").expand() 
}

export function copperButton_mouseOut(event) {
$w("#copperMenu").collapse() 
}

export function copperMenu_mouseIn(event) {
$w("#copperMenu").expand() 
}

export function copperMenu_mouseOut(event) {
$w("#copperMenu").collapse() 
}

export function turkishCeramicsButton_mouseIn_1(event) {
$w("#turkishCeramicsMenu").expand() 
}

export function turkishCeramicsButton_mouseOut_1(event) {
$w("#turkishCeramicsMenu").collapse() 
}


